/** Shared brand tokens — single source for marketing + platform themes */

export const brandFonts = {
  display: "'Syne', 'TickitOne', Helvetica, Arial, sans-serif",
  body: "'Plus Jakarta Sans', 'TickitTwo', Helvetica, Arial, sans-serif",
  platformBody: "'Nunito', 'Plus Jakarta Sans', 'TickitTwo', Helvetica, Arial, sans-serif",
};

export const brandPurple = {
  p900: "#1E0550",
  p800: "#30097A",
  p700: "#46109B",
  p600: "#5A1EC8",
  p500: "#7B3FE0",
  p400: "#9D6CF0",
  p300: "#C4A8F8",
  p200: "#E0D4FC",
  p100: "#F0EAFF",
  p50: "#F8F5FF",
};

export const brandGray = {
  gray900: "#0F0A1A",
  gray700: "#2D2440",
  gray600: "#4A3D60",
  gray500: "#6B5E80",
  gray400: "#9488A8",
  gray200: "#E4E0EB",
  gray100: "#F2F0F5",
  gray50: "#F8F7FA",
};

export const brandRadius = {
  sm: "9px",
  md: "12px",
  lg: "18px",
  xl: "24px",
};

export const brandSemantic = {
  danger: "#E63B3B",
  warn: "#F59E0B",
  success: "#10B981",
  info: "#3B82F6",
};

export const topBarHeightPx = 60;
export const platformNavHeightPx = 60;

export const STORAGE_THEME_KEY = "tickit-theme-mode";
